import { render, staticRenderFns } from "./directives-project-card.component.vue?vue&type=template&id=27a5f0a2&scoped=true&"
import script from "./directives-project-card.component.vue?vue&type=script&lang=ts&"
export * from "./directives-project-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./directives-project-card.component.vue?vue&type=style&index=0&id=27a5f0a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5f0a2",
  null
  
)

export default component.exports